import { Box, Tabs, Tab } from '@mui/material';
import React, { useMemo, useState } from 'react';
import { DashboardProvider } from '../Dashboard/useDashboard';
import Approved from './Approved';

import TabPanel from '../../components/TabPanel';
import BelowTarget from './BelowTarget';
import ForApproval from './ForApproval';

import CWPContext from './useCWPContext';

export default function Approvals() {
  const [activeTab, setActiveTab] = useState(0);
  const [reloadTable, setReloadTable] = useState({
    below_target: 0,
    approved: 0,
  });
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  const handleReloadTable = (slug) => {
    setReloadTable({ ...reloadTable, [slug]: Math.random() });
  };

  return (
    <DashboardProvider>
      <CWPContext.Provider
        value={useMemo(
          () => ({
            reloadTable,
            activeTab,
            onReloadTable: handleReloadTable,
          }),
          [activeTab, reloadTable, handleReloadTable],
        )}
      >
        <Box padding={4}>
          <Box sx={{ backgroundColor: '#fff' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={activeTab} onChange={handleChange} aria-label='basic tabs example'>
                <Tab
                  label='CWP For Approval'
                  id='cwp-for-approval'
                  aria-controls='cwp-for-approval'
                />
                <Tab label='Approved CWP' id='approved-cwp' aria-controls='approved-cwp' />
                <Tab
                  label='CWP Below Target'
                  id='cwp-below-target'
                  aria-controls='cwp-below-target'
                />
              </Tabs>
            </Box>
            <TabPanel value={activeTab} index={0}>
              <ForApproval />
            </TabPanel>
            <TabPanel value={activeTab} index={1}>
              <Approved />
            </TabPanel>
            <TabPanel value={activeTab} index={2}>
              <BelowTarget />
            </TabPanel>
          </Box>
        </Box>
      </CWPContext.Provider>
    </DashboardProvider>
  );
}
